import React, { ReactElement } from 'react';
import Button from '../button/button.component';
import TextBlock from '../text-block/text-block.component';
import OktaIcon from '../../icons/okta-icon';
import FormatService from '../../services/format-service';
import useStylesOktaButton from './okta-button.styles';

const OktaButton: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    className,
    onClick,
  } = props;

  const { classes } = useStylesOktaButton();

  return (
    <Button
      isActive
      className={FormatService.formatClassNames(classes.oktaButton, className)}
      onClick={onClick}
    >
      <OktaIcon />
      <TextBlock>
        Sign In with Okta
      </TextBlock>
    </Button>
  );
});

export default OktaButton;
